import { Box, Chip } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import "./../styles.css";
import DoneIcon from "@mui/icons-material/Done";
import React from "react";

const useStyles = makeStyles((theme) => ({
  arrow: {
    display: "flex",
    alignItems: "center",
  },
  active: {
    color: "white !important",
    backgroundColor: theme.palette.gif.blue.color,
    "&:hover":{
      backgroundColor:theme.palette.gif.blue.color
    }
  },
  doneChip: {
    backgroundColor: theme.palette.gif.green.color,
    color: "white",
    fontWeight: 700,
    fontSize: 10,
  },
  inProgressChip: {
    backgroundColor: theme.palette.gif.yellow.color,
    fontWeight: 700,
    fontSize: 10,
  },
  done:{
    color:theme.palette.gif.green.color,
  },
  block: {
    cursor: "pointer",
  },
  activeDone:{
    color:"blue",
  }
}));
export default function ProcessBlock(props) {
  const classes = useStyles();
  const { text, status, active, ...rest } = props;
  const done = status === 2;
  const inProgress = status === 1;
  const statuses = {
    1: "in-progress",
    2: "done",
  };
  const doneChip = (
    <Chip
      className={classes.doneChip}
      label="DONE"
      size="small"
      color="primary"
      icon={<DoneIcon fontSize="small" />}
    />
  );
  const inProgressChip = (
    <Chip className={classes.inProgressChip} label="IN PROGRESS" size="small" />
  );

  return (
    <Box
      {...rest}
      className={`${active ? classes.active : classes.block
      } ${done?classes.done:''} stepper__item`}
    >
      <Box className={`arrow ${done?classes.done:''} ${active?classes.active:''} ${classes[statuses[status]]}`}>{text}</Box>
      {done ? doneChip : ""}
      {inProgress ? inProgressChip : ""}
    </Box>
  );
}
